function programmaticFocus (el, timeout) {
  if ( timeout === void 0 ) timeout = 1000;

  el.setAttribute('tabindex', '-1');
  el.focus();
  setTimeout(function () { return el.removeAttribute('tabindex'); }, timeout);
}

//

var focusedTags = new RegExp('^(a|select|input|button|textarea)', 'i');

var script = {
  name: 'VueSkipToSingle',

  props: {
    label: {
      type: String,
      default: 'Skip to main content'
    },
    to: {
      type: String,
      default: '#main'
    }
  },

  methods: {
    handleFocusElement: function handleFocusElement (ref) {
      var target = ref.target;

      this.focusElement(target.getAttribute('href').substring(1));
    },

    focusElement: function focusElement (id) {
      if (!id) { return }
      var element = window.document.getElementById(id);
      if (!element) { return }
      if (!focusedTags.test(element.tagName.toLowerCase())) { return programmaticFocus(element) }
      element.focus();
    }
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    var options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    var hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            var originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            var existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

/* script */
var __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"vue-skip-to__link",attrs:{"href":_vm.to},on:{"click":function($event){$event.preventDefault();return _vm.handleFocusElement($event)},"focus":function($event){return _vm.$emit('focused', true)},"blur":function($event){return _vm.$emit('focused', false)}}},[_vm._t("default",[_vm._v(_vm._s(_vm.label))])],2)};
var __vue_staticRenderFns__ = [];

  /* style */
  var __vue_inject_styles__ = undefined;
  /* scoped */
  var __vue_scope_id__ = undefined;
  /* module identifier */
  var __vue_module_identifier__ = undefined;
  /* functional template */
  var __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__ = normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

//

var script$1 = {
  name: 'VueSkipToList',

  props: {
    listLabel: {
      type: String,
      default: 'Skip to'
    },
    to: {
      validator: function (val) {
        return Array.isArray(val) &&
          val.every(function (ref) {
            var anchor = ref.anchor;
            var label = ref.label;

            return (
            typeof anchor === 'string' &&
              anchor.indexOf('#') === 0 &&
              typeof String(label) === 'string'
          );
        })
      }
    }
  },

  components: {
    VueSkipToSingle: __vue_component__
  },

  methods: {
    handleKeydown: function handleKeydown (ref) {
      var key = ref.key;
      var target = ref.target;

      var parent = target.parentElement;
      var itemList = /(ArrowUp|Up)/g.test(key) ? parent.previousElementSibling : parent.nextElementSibling;

      if (!itemList) { return }

      var link = itemList.getElementsByTagName('a');
      if (link.length) { link[0].focus(); }
    }
  }
};

/* script */
var __vue_script__$1 = script$1;

/* template */
var __vue_render__$1 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"vue-skip-to__nav",attrs:{"aria-labelledby":"list-title"}},[_c('span',{attrs:{"id":"list-title"}},[_vm._v(_vm._s(_vm.listLabel))]),_vm._v(" "),_c('ul',{staticClass:"vue-skip-to__nav-list"},_vm._l((_vm.to),function(el){return _c('li',{key:el.anchor,staticClass:"vue-skip-to__nav-list-item",on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }$event.preventDefault();return _vm.handleKeydown($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }$event.preventDefault();return _vm.handleKeydown($event)}]}},[_c('VueSkipToSingle',{attrs:{"to":el.anchor,"aria-label":el.ariaLabel || el.label},on:{"focused":function($event){return _vm.$emit('focus-within', $event)}}},[_vm._v("\n        "+_vm._s(el.label)+"\n      ")])],1)}),0)])};
var __vue_staticRenderFns__$1 = [];

  /* style */
  var __vue_inject_styles__$1 = undefined;
  /* scoped */
  var __vue_scope_id__$1 = undefined;
  /* module identifier */
  var __vue_module_identifier__$1 = undefined;
  /* functional template */
  var __vue_is_functional_template__$1 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__$1 = normalizeComponent(
    { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    false,
    undefined,
    undefined,
    undefined
  );

//

var script$2 = {
  name: 'VueSkipTo',

  props: {
    listLabel: {
      type: String,
      default: 'Skip to'
    },
    label: {
      type: String,
      default: 'Skip to main content'
    },
    to: {
      type: [String, Array],
      default: '#main'
    }
  },

  data: function data () {
    return {
      focused: false
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    if (this.$route) {
      this.$watch('$route.path', function () {
        this$1.$nextTick(function () { return programmaticFocus(this$1.$refs.skipTo); });
      });
    }
  },

  computed: {
    isList: function isList () {
      return Array.isArray(this.to)
    },

    comp: function comp () {
      return this.isList ? __vue_component__$1 : __vue_component__
    },

    props: function props () {
      if (this.isList) { return { listLabel: this.listLabel, to: this.to } }
      return { label: this.label, to: this.to }
    }
  },

  methods: {
    focusWithin: function focusWithin (val) {
      this.focused = val;
    }
  }
};

var isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return function (id, style) { return addStyle(id, style); };
}
var HEAD;
var styles = {};
function addStyle(id, css) {
    var group = isOldIE ? css.media || 'default' : id;
    var style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        var code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                { style.element.setAttribute('media', css.media); }
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            var index = style.ids.size - 1;
            var textNode = document.createTextNode(code);
            var nodes = style.element.childNodes;
            if (nodes[index])
                { style.element.removeChild(nodes[index]); }
            if (nodes.length)
                { style.element.insertBefore(textNode, nodes[index]); }
            else
                { style.element.appendChild(textNode); }
        }
    }
}

/* script */
var __vue_script__$2 = script$2;

/* template */
var __vue_render__$2 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"skipTo",staticClass:"vue-skip-to",class:{ 'focused': _vm.focused }},[_c(_vm.comp,_vm._b({tag:"component",on:{"focused":_vm.focusWithin,"focus-within":_vm.focusWithin}},'component',_vm.props,false))],1)};
var __vue_staticRenderFns__$2 = [];

  /* style */
  var __vue_inject_styles__$2 = function (inject) {
    if (!inject) { return }
    inject("data-v-c261e76a_0", { source: ".vue-skip-to *{padding:0;margin:0;box-sizing:border-box}.vue-skip-to{position:fixed;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border-width:0}.vue-skip-to.focused,.vue-skip-to:hover{left:0;top:0;clip:auto;height:auto;width:auto;background-color:#fff;border:2px solid #333}.vue-skip-to__nav-list{list-style-type:none}.vue-skip-to__link,.vue-skip-to__nav>span{display:block;padding:8px 16px;color:#333;font-size:18px}.vue-skip-to__nav>span{border-bottom:2px solid #333;font-weight:700}.vue-skip-to__link{text-decoration:none}.vue-skip-to__link:focus{outline:0;background-color:#333;color:#f2f2f2}", map: undefined, media: undefined });

  };
  /* scoped */
  var __vue_scope_id__$2 = undefined;
  /* module identifier */
  var __vue_module_identifier__$2 = undefined;
  /* functional template */
  var __vue_is_functional_template__$2 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__$2 = normalizeComponent(
    { render: __vue_render__$2, staticRenderFns: __vue_staticRenderFns__$2 },
    __vue_inject_styles__$2,
    __vue_script__$2,
    __vue_scope_id__$2,
    __vue_is_functional_template__$2,
    __vue_module_identifier__$2,
    false,
    createInjector,
    undefined,
    undefined
  );

function install (Vue) {
  if (install.installed) { return }
  install.installed = true;
  Vue.component('VueSkipTo', __vue_component__$2);
}

// auto install
if (typeof window !== 'undefined' && typeof window.Vue !== 'undefined') {
  window.Vue.use(install);
}

export default install;
export { __vue_component__$2 as VueSkipTo };
